import { render, staticRenderFns } from "./Stockin.vue?vue&type=template&id=d65d3b8a&scoped=true"
import script from "./Stockin.vue?vue&type=script&lang=js"
export * from "./Stockin.vue?vue&type=script&lang=js"
import style0 from "./Stockin.vue?vue&type=style&index=0&id=d65d3b8a&prod&scoped=true&lang=css"
import style1 from "./Stockin.vue?vue&type=style&index=1&id=d65d3b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65d3b8a",
  null
  
)

export default component.exports